import { useState } from "react";
import { motion } from "framer-motion";


const SmoothAccordion = ({data}) => {
  const [openIndex, setOpenIndex] = useState(0); // Set first item open by default

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full border-t border-black">
      {data.map((item, index) => (
        <div key={index} className="border-b border-black">
          <button
            onClick={() => toggleItem(index)}
            className="w-full flex justify-between items-center py-4 pl-0 text-3xl font-medium text-black cursor-pointer border-0"
          >
            {item.title}
            {openIndex === index ? (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14" />
              </svg>
            ) : (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 5v14M5 12h14" />
              </svg>
            )}
          </button>
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{
              height: openIndex === index ? "auto" : 0,
              opacity: openIndex === index ? 1 : 0,
            }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="py-4">{item.content}</div>
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export default SmoothAccordion;
